import { RecipeType } from 'features/Recipes/types'

export const getProteinFromSlug = (slug: string): RecipeType | null => {
    const parts: string[] = slug.split('-');
    
    const proteins = ['chicken', 'beef', 'venison', 'lamb', 'duck', 'turkey'] as const;

    const protein = parts.find(part => (proteins as readonly string[]).includes(part as RecipeType));
    
    return protein as RecipeType | null;
}